import React from "react";

import { Trans } from "react-i18next";
import i18next from "i18next";

import { Button, Collapse, Icon, Tooltip, Callout } from "@blueprintjs/core";

import SubscriberManagement from "./UserManagement/SubscriberManagement";
import ServerSelect from "../Structure/ServerSelector";
import { TableCustom } from "../Structure/navbar/blueprintTableincludes";
import { parkLookup } from "../Structure/ParkSelector";
import { userIcons } from "../../utils/mef";

export class SubscribersTable extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      waiting: false,
      parkLookup: parkLookup(),
      deviceLookup: JSON.parse(localStorage.getItem("deviceLookup") || "{}"),
      server: 0,
    };

    this.handleOpenClose = this.handleOpenClose.bind(this);
  }

  handleOpenClose() {
    this.setState({ isOpen: !this.state.isOpen });

    if (this.state.isOpen === false) {
      // open
      this.setState({ loading: true });
    }
  }

  render() {
    return (
      <Callout
        title={
          <Button onClick={this.handleOpenClose} icon={userIcons[2]}>
            <Trans>manage subscribers</Trans>
          </Button>
        }
      >
        <Collapse
          isOpen={this.state.isOpen}
          onClose={() =>
            this.setState({ isOpen: false, loading: false, plate: "" })
          }
        >
          <ServerSelect onSelect={(id, srv) => this.setState({ server: id })} />
          <TableCustom
            //{NUMECLE":1,"NUMECATE":1,"SUPPOEXT":"","INTERDIC":false,"INTERRUP":false,"SURVEILL":false,"DATEINTE":"20251231","NBRBADGE":1,"DMVTEQUI":1,"DMVTPARC":1,"DMVTDATE":"000000000000","DATELIMI":"","MONTPAYE":0,"DATEENTP":"000000000000","DATEENSP":"000000000000","NBRBADPR":0,"CONTRAT":0,"NUMPLACE":"N","IMMATRIC":"","NUMCARTE":0,"IDCMS":"","NUMABON2":0,"MATRICULE":"","LISTPK":"","CLEENCODE":0,"IMMATRI2":"","IMMATRI3":"","IMMATRI4":"","CODESITE":0},
            paging={true}
            url={"/subscribers?srv=" + this.state?.server}
            columns={[
              {
                title: <Trans>subscriber number</Trans>,
                field: "NUMEABON",
                sortable: true,
                render: (raw) => raw.NUMEABON,
              },
              /* {
                title: <Trans>Name</Trans>,
              }, //RGPD ? */
              {
                title: <Trans>validity period</Trans>,
                field: "VALIDFIN",
                sortable: true,
                render: (raw) =>
                  new Date(raw.VALIDDEB).toLocaleDateString(i18next.language) +
                  " - " +
                  new Date(raw.VALIDFIN).toLocaleDateString(i18next.language),
              },
              {
                title: <Trans>park</Trans>,
                field: "NUMEPARC",
                sortable: true,
                render: (raw) =>
                  this.state.parkLookup[this.state.server + "_" + raw.NUMEPARC],
              },
              {
                title: <Trans>status</Trans>,
                field: "PRESENCE",
                sortable: true,
                render: (raw) =>
                  raw.PRESENCE ? (
                    <span>
                      <Trans>present in park</Trans>{" "}
                      <b>
                        {
                          this.state.parkLookup[
                            this.state.server + "_" + raw.NUMEPARC
                          ]
                        }
                      </b>
                    </span>
                  ) : (
                    <Trans>absent</Trans>
                  ),
              },
              {
                title: <Trans>last move</Trans>,
                field: "DMVTDATE",
                sortable: true,
                render: (raw) => (
                  <span>
                    {raw.DMVTDATE !== "1970-01-01T00:00:00.000Z"
                      ? new Date(raw.DMVTDATE).toLocaleDateString(
                          i18next.language
                        )
                      : ""}{" "}
                    <Trans>on park</Trans>{" "}
                    {
                      this.state.parkLookup[
                        this.state.server + "_" + raw.DMVTPARC
                      ]
                    }
                    {raw.DMVTEQUI > 0 ? (
                      <>
                        ,{" "}
                        {
                          this.state.deviceLookup[
                            this.state.server + "_" + raw.DMVTEQUI
                          ]
                        }{" "}
                      </>
                    ) : (
                      <></>
                    )}
                  </span>
                ),
              },
              {
                title: "Actions",
                sortable: false,
                render: (raw) => (
                  <Tooltip content={<Trans>edit subscriber</Trans>}>
                    <Icon
                      icon="info-sign"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.setState({ editSubscriber: raw.NUMEABON })
                      }
                    />
                  </Tooltip>
                ),
              },
            ]}
          />
        </Collapse>
        {this.state.editSubscriber !== undefined ? (
          <SubscriberManagement
            id={this.state.editSubscriber}
            onClose={() => {
              this.setState({ editSubscriber: undefined });
            }}
            onUpdate={() => {
              this.setState({ editSubscriber: undefined });
            }}
            server={this.state.server}
          />
        ) : null}
      </Callout>
    );
  }
}
